const pageTitles = {
  about: "Johnny Trinh - Fullstack Developer | Portfolio",
  skills: "Skills & Technologies - Johnny Trinh | Fullstack Developer",
  chatbot: "AI Chatbot Assistant - Johnny Trinh | Portfolio",
  projects: "Projects & Work - Johnny Trinh | Fullstack Developer",
  hackathons: "Hackathons & Competitions - Johnny Trinh | Developer",
  achievements: "Achievements & Milestones - Johnny Trinh | Portfolio",
  contact: "Contact Johnny Trinh - Fullstack Developer",
  reviews: "Reviews & Testimonials - Johnny Trinh | Portfolio",
  settings: "Settings - Johnny Trinh Portfolio",
  notFound: "404 - Page Not Found | Johnny Trinh Portfolio",
};

export default pageTitles;
